"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdventureManager = void 0;
const Adventure_1 = require("./models/Adventure");
const AdventureParser_1 = require("./parser/AdventureParser");
const path = __importStar(require("path"));
const fs = __importStar(require("fs"));
const pathConfig_1 = require("./utils/pathConfig");
const entityListForeign_1 = require("./utils/entityListForeign");
class AdventureManager {
    constructor() {
        this.adventures = new Map();
        this.defaultsCache = new Map();
        // Set adventures directory using PathConfig
        try {
            this.adventuresDirectory = pathConfig_1.PathConfig.getAdventuresDirectory();
            // Defaults path using PathConfig
            this.defaultsBasePath = pathConfig_1.PathConfig.getRequiredScenesDirectory();
        }
        catch (error) {
            // If path resolution fails, leave undefined
        }
    }
    static getInstance() {
        if (!AdventureManager.instance) {
            AdventureManager.instance = new AdventureManager();
        }
        return AdventureManager.instance;
    }
    /**
     * Set the base path for required default scenes directory
     */
    setDefaultsBasePath(defaultsBasePath) {
        this.defaultsBasePath = defaultsBasePath;
    }
    /**
     * Resolve snippet roots and adventure directory for the preprocessor.
     * When adventureBasePath is the adventure directory (directory format), pass it as adventureDirectory
     * so adventure-local snippets are used. Global snippets root is from PathConfig.
     */
    getParserOptionsForAdventure(adventureId, adventureBasePath) {
        let snippetsRoot;
        try {
            snippetsRoot = pathConfig_1.PathConfig.getSnippetsDirectory();
        }
        catch {
            // Path resolution may fail in some environments; skip snippet expansion
        }
        const leafId = adventureId.includes('/')
            ? adventureId.split('/').filter(Boolean).pop()
            : adventureId;
        const adventureDirectory = adventureBasePath && path.basename(adventureBasePath) === leafId
            ? adventureBasePath
            : undefined;
        return { snippetsRoot, adventureDirectory };
    }
    loadAdventure(adventureId, adventureData, adventureBasePath) {
        // console.log('AdventureManager: Starting to load adventure:', adventureId);
        // console.log('AdventureManager: Adventure data:', adventureData.substring(0, 100));
        const parserOptions = this.getParserOptionsForAdventure(adventureId, adventureBasePath);
        const parser = new AdventureParser_1.AdventureParser(adventureBasePath, parserOptions);
        const result = parser.parse(adventureData, adventureId);
        // Inject required default scenes before constructing the Adventure and running duplicate-id validation
        try {
            this.injectRequiredScenesIfMissing(result, adventureBasePath, parserOptions);
        }
        catch (injectionError) {
            throw new Error(injectionError instanceof Error ? injectionError.message : String(injectionError));
        }
        // Validate inline option targets after injection so that required-scene targets (e.g. session_info) exist
        const inlineOptionErrors = AdventureParser_1.AdventureParser.validateInlineOptionTargets(result.adventure);
        result.errors.push(...inlineOptionErrors);
        // console.log('AdventureManager: Parse result errors:', result.errors.length);
        // console.log('AdventureManager: Parse result title:', result.adventure.title);
        // console.log('AdventureManager: Parse result characters:', result.adventure.characters.length);
        // console.log('AdventureManager: Parse result scenes:', result.adventure.scenes.length);
        // Only throw errors for actual errors, not warnings
        const actualErrors = result.errors.filter(error => error.type !== 'warning');
        if (actualErrors.length > 0) {
            console.log('AdventureManager: Throwing parse errors:', actualErrors.map(e => e.message));
            throw new Error(`Adventure parsing errors: ${actualErrors.map(e => e.message).join(', ')}`);
        }
        // Additional validation: require a title
        if (!result.adventure.title || result.adventure.title.trim() === '') {
            // console.log('AdventureManager: Throwing title validation error');
            throw new Error('Adventure must have a title (first line should start with #)');
        }
        // Additional validation: require at least one character
        if (!result.adventure.characters || result.adventure.characters.length === 0) {
            // console.log('AdventureManager: Throwing character validation error');
            throw new Error('Adventure must have at least one character defined in the Characters section');
        }
        // Additional validation: require at least one scene
        if (!result.adventure.scenes || result.adventure.scenes.length === 0) {
            // console.log('AdventureManager: Throwing scene validation error');
            throw new Error('Adventure must have at least one scene defined in the Scenes section');
        }
        const adventure = new Adventure_1.Adventure(result.adventure, adventureId);
        const validationErrors = adventure.validate();
        if (validationErrors.length > 0) {
            // console.log('AdventureManager: Throwing adventure validation errors:', validationErrors);
            throw new Error(`Adventure validation errors: ${validationErrors.join(', ')}`);
        }
        const foreignSourceErrors = this.validateForeignEntityListSources(adventure);
        if (foreignSourceErrors.length > 0) {
            throw new Error(`Adventure validation errors: ${foreignSourceErrors.join(', ')}`);
        }
        // console.log('AdventureManager: Adventure loaded successfully');
        this.adventures.set(adventureId, adventure);
        return adventure;
    }
    /**
     * When a foreign `<Entity-List source=adventure:…>` targets an adventure that is
     * already loaded, require `Library: true`. Unknown / not-yet-loaded sources are
     * allowed (forward reference); runtime hydrate warns if still missing.
     */
    validateForeignEntityListSources(adventure) {
        const errors = [];
        for (const sourceId of (0, entityListForeign_1.collectForeignLibrarySourceIds)(adventure)) {
            const source = this.adventures.get(sourceId);
            if (!source) {
                continue;
            }
            if (source.library !== true) {
                errors.push(`<Entity-List source=adventure:${sourceId}> targets adventure '${sourceId}' which is not Library: true`);
            }
        }
        return errors;
    }
    getAdventure(adventureId) {
        return this.adventures.get(adventureId);
    }
    listAdventures() {
        return Array.from(this.adventures.keys());
    }
    getAdventureTags(adventureId) {
        const adventure = this.adventures.get(adventureId);
        if (!adventure) {
            return [];
        }
        return adventure.tags ? [...adventure.tags] : [];
    }
    listAdventureIdsByTag(tag) {
        const normalized = tag.trim().toLowerCase();
        if (!normalized) {
            return [];
        }
        return Array.from(this.adventures.entries())
            .filter(([, adventure]) => (adventure.tags ?? []).includes(normalized))
            .map(([id]) => id)
            .sort();
    }
    validateAdventure(adventureId) {
        const adventure = this.getAdventure(adventureId);
        if (!adventure) {
            return [`Adventure '${adventureId}' not found`];
        }
        return adventure.validate();
    }
    hasAdventure(adventureId) {
        return this.adventures.has(adventureId);
    }
    removeAdventure(adventureId) {
        return this.adventures.delete(adventureId);
    }
    clearAdventures() {
        this.adventures.clear();
    }
    /**
     * Clear the defaults cache (required scenes cache)
     * Useful when required scenes are modified and need to be reloaded
     */
    clearDefaultsCache() {
        this.defaultsCache.clear();
    }
    /**
     * Clear a specific required scene from the defaults cache
     * @param requiredSceneId The ID of the required scene to clear from cache
     */
    clearDefaultsCacheForScene(requiredSceneId) {
        // If we have the defaults base path, we can construct the cache key
        if (this.defaultsBasePath) {
            const cacheKey = path.join(this.defaultsBasePath, requiredSceneId + '.sad');
            this.defaultsCache.delete(cacheKey);
        }
        else {
            // If no base path, clear all (shouldn't happen but be safe)
            this.defaultsCache.clear();
        }
    }
    // ---- Required Scenes (Defaults) Support ----
    injectRequiredScenesIfMissing(parseResult, adventureBasePath, parserOptions) {
        const defaultsDir = this.defaultsBasePath;
        if (!defaultsDir)
            return; // No defaults configured
        const requiredIds = this.discoverRequiredSceneIds(defaultsDir);
        if (requiredIds.length === 0)
            return;
        const presentSceneIds = new Set((parseResult.adventure.scenes || []).map(s => s.id));
        const missingIds = requiredIds.filter(id => !presentSceneIds.has(id));
        if (missingIds.length === 0)
            return;
        for (const sceneId of missingIds) {
            // Re-check in case a previous merge added this scene (e.g. adventure_menu.sad also adds session_info)
            const presentNow = new Set((parseResult.adventure.scenes || []).map(s => s.id));
            if (presentNow.has(sceneId))
                continue;
            const defaultsAdventure = this.loadDefaultsAdventure(sceneId, defaultsDir, adventureBasePath, parserOptions);
            // Validate that defaults provide the required scene id
            const hasScene = (defaultsAdventure.scenes || []).some(s => s.id === sceneId);
            if (!hasScene) {
                throw new Error(`Required scene '${sceneId}' is missing in defaults file '${sceneId}.sad' under '${defaultsDir}'.`);
            }
            // Check for duplicate IDs before merging (other than the missing scene which isn't present yet)
            this.assertNoConflicts(parseResult.adventure, defaultsAdventure);
            // Merge content
            this.mergeAdventureContent(parseResult.adventure, defaultsAdventure);
            // Record a non-fatal warning
            parseResult.errors.push({
                line: 0,
                message: `Default required scene '${sceneId}' injected from '${path.join(defaultsDir, sceneId + '.sad')}'.`,
                type: 'warning'
            });
        }
    }
    discoverRequiredSceneIds(defaultsDir) {
        try {
            if (!fs.existsSync(defaultsDir))
                return [];
            const files = fs.readdirSync(defaultsDir, { withFileTypes: true });
            return files
                .filter(d => d.isFile() && d.name.toLowerCase().endsWith('.sad'))
                .map(d => d.name.replace(/\.sad$/i, ''));
        }
        catch {
            return [];
        }
    }
    loadDefaultsAdventure(requiredId, defaultsDir, adventureBasePath, parserOptions) {
        const cacheKey = path.join(defaultsDir, requiredId + '.sad');
        const cached = this.defaultsCache.get(cacheKey);
        if (cached)
            return cached;
        const filePath = cacheKey;
        if (!fs.existsSync(filePath)) {
            throw new Error(`Defaults file not found for required scene '${requiredId}': ${filePath}`);
        }
        const content = fs.readFileSync(filePath, 'utf-8');
        // Wrap .sad content with a minimal header, Characters, and Players so parser validations pass
        const wrapped = `# Defaults: ${requiredId}\nDescription:""""""\n\n` +
            `## Players\n\n### host\nStarting Character: DefaultCharacter\n\n` +
            `## Characters\n\n### DefaultCharacter\nDescription:"""Default character for defaults parsing"""\nStarting Scene: ${requiredId}\n\n` +
            `${content}\n`;
        // Pass adventureBasePath and parserOptions for sub-adventure and snippet resolution in defaults files
        const parser = new AdventureParser_1.AdventureParser(adventureBasePath, parserOptions);
        const result = parser.parse(wrapped, `defaults:${requiredId}`);
        // Only treat syntax/validation as fatal here
        const fatal = result.errors.filter(e => e.type !== 'warning');
        if (fatal.length > 0) {
            const msg = fatal.map(e => e.message).join('; ');
            throw new Error(`Failed to parse defaults for '${requiredId}': ${msg}`);
        }
        // Optionally cache
        this.defaultsCache.set(cacheKey, result.adventure);
        return result.adventure;
    }
    assertNoConflicts(target, src) {
        const sceneIds = new Set((target.scenes || []).map(s => s.id));
        const itemIds = new Set((target.items || []).map(i => i.tag));
        const locationIds = new Set((target.locations || []).map(l => l.tag));
        const statNames = new Set((target.stats || []).map(s => s.name));
        const conflictingScenes = (src.scenes || []).map(s => s.id).filter(id => sceneIds.has(id));
        const conflictingItems = (src.items || []).map(i => i.tag).filter(id => itemIds.has(id));
        const conflictingLocations = (src.locations || []).map(l => l.tag).filter(id => locationIds.has(id));
        const conflictingStats = (src.stats || []).map(s => s.name).filter(n => statNames.has(n));
        const conflicts = [];
        if (conflictingScenes.length)
            conflicts.push(`scenes: ${conflictingScenes.join(', ')}`);
        if (conflictingItems.length)
            conflicts.push(`items: ${conflictingItems.join(', ')}`);
        if (conflictingLocations.length)
            conflicts.push(`locations: ${conflictingLocations.join(', ')}`);
        if (conflictingStats.length)
            conflicts.push(`stats: ${conflictingStats.join(', ')}`);
        if (conflicts.length) {
            throw new Error(`Default content conflicts with existing adventure ids (${conflicts.join(' | ')}).`);
        }
    }
    mergeAdventureContent(target, src) {
        // Merge scenes/items/locations/stats by simple append (we pre-checked conflicts)
        if (!target.scenes)
            target.scenes = [];
        if (!target.items)
            target.items = [];
        if (!target.locations)
            target.locations = [];
        if (!target.stats)
            target.stats = [];
        (src.items || []).forEach(i => target.items.push(i));
        (src.locations || []).forEach(l => target.locations.push(l));
        (src.stats || []).forEach(s => target.stats.push(s));
        (src.scenes || []).forEach(s => target.scenes.push(s));
    }
}
exports.AdventureManager = AdventureManager;
//# sourceMappingURL=AdventureManager.js.map